module.exports = __webpack_public_path__ + "static/media/app_store.209deba5.svg";